/**
 * Convert a list of objects to CSV and trigger a download.
 * @param {string} filename - target filename
 * @param {Array<Object>} rows - data rows
 * @param {Array<{key:string,label:string,fmt?:(v:any,row:any)=>string}>} columns - columns to include
 */
export function exportToCSV(filename, rows, columns) {
  const escape = (v) => {
    if (v === null || v === undefined) return "";
    const s = String(v).replace(/"/g, '""');
    return /[",\n]/.test(s) ? `"${s}"` : s;
  };
  const header = columns.map(c => escape(c.label)).join(",");
  const body = rows.map(r =>
    columns.map(c => escape(c.fmt ? c.fmt(r[c.key], r) : r[c.key])).join(",")
  ).join("\n");
  const csv = header + "\n" + body;
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
